import { createContext, useContext, type FC, type ReactNode } from 'react';

/**
 * Смена ширины колонки названий столбчатой диаграммы перетаскиванием её границы — есть только у
 * диаграммы правящегося дашборда: на применённом граница не перетаскивается.
 *
 * Идёт контекстом, а не пропом: полосы рисует представление типа глубоко внутри карточки, и проп
 * прошёл бы через все представления, которым ширина названий не нужна.
 */
const ChartLabelWidthContext = createContext<((labelWidth: number) => void) | null>(null);

type Props = {
  /** Новая доля ширины диаграммы под названия */
  onChange: (labelWidth: number) => void;
  children: ReactNode;
};

/** Разрешает перетаскивать границу колонки названий диаграмме, отрисованной внутри. */
export const ChartLabelWidthProvider: FC<Props> = ({ onChange, children }) => (
  <ChartLabelWidthContext.Provider value={onChange}>{children}</ChartLabelWidthContext.Provider>
);

/** Смена ширины колонки названий текущей диаграммы; `null` — граница не перетаскивается. */
export const useChartLabelWidthChange = (): ((labelWidth: number) => void) | null => useContext(ChartLabelWidthContext);
